/**
 * ISO 3166-1 alpha-2 code and English name for every country a user can
 * be assigned to, sorted by name.
 *
 * The pairs are spelled out rather than resolved through
 * Intl.DisplayNames at runtime: the label a doctor picked and the label
 * an admin reads on the dashboard have to be the same string, and
 * Intl's names shift with the browser's locale data.
 */
const COUNTRIES = [
  ['AF', "Afghanistan"],
  ['AX', "Åland Islands"],
  ['AL', "Albania"],
  ['DZ', "Algeria"],
  ['AS', "American Samoa"],
  ['AD', "Andorra"],
  ['AO', "Angola"],
  ['AI', "Anguilla"],
  ['AG', "Antigua & Barbuda"],
  ['AR', "Argentina"],
  ['AM', "Armenia"],
  ['AW', "Aruba"],
  ['AU', "Australia"],
  ['AT', "Austria"],
  ['AZ', "Azerbaijan"],
  ['BS', "Bahamas"],
  ['BH', "Bahrain"],
  ['BD', "Bangladesh"],
  ['BB', "Barbados"],
  ['BY', "Belarus"],
  ['BE', "Belgium"],
  ['BZ', "Belize"],
  ['BJ', "Benin"],
  ['BM', "Bermuda"],
  ['BT', "Bhutan"],
  ['BO', "Bolivia"],
  ['BA', "Bosnia & Herzegovina"],
  ['BW', "Botswana"],
  ['BR', "Brazil"],
  ['VG', "British Virgin Islands"],
  ['BN', "Brunei"],
  ['BG', "Bulgaria"],
  ['BF', "Burkina Faso"],
  ['BI', "Burundi"],
  ['KH', "Cambodia"],
  ['CM', "Cameroon"],
  ['CA', "Canada"],
  ['CV', "Cape Verde"],
  ['BQ', "Caribbean Netherlands"],
  ['KY', "Cayman Islands"],
  ['CF', "Central African Republic"],
  ['TD', "Chad"],
  ['CL', "Chile"],
  ['CN', "China"],
  ['CX', "Christmas Island"],
  ['CC', "Cocos (Keeling) Islands"],
  ['CO', "Colombia"],
  ['KM', "Comoros"],
  ['CG', "Congo - Brazzaville"],
  ['CD', "Congo - Kinshasa"],
  ['CK', "Cook Islands"],
  ['CR', "Costa Rica"],
  ['CI', "Côte d’Ivoire"],
  ['HR', "Croatia"],
  ['CU', "Cuba"],
  ['CW', "Curaçao"],
  ['CY', "Cyprus"],
  ['CZ', "Czechia"],
  ['DK', "Denmark"],
  ['DJ', "Djibouti"],
  ['DM', "Dominica"],
  ['DO', "Dominican Republic"],
  ['EC', "Ecuador"],
  ['EG', "Egypt"],
  ['SV', "El Salvador"],
  ['GQ', "Equatorial Guinea"],
  ['ER', "Eritrea"],
  ['EE', "Estonia"],
  ['SZ', "Eswatini"],
  ['ET', "Ethiopia"],
  ['FK', "Falkland Islands"],
  ['FO', "Faroe Islands"],
  ['FJ', "Fiji"],
  ['FI', "Finland"],
  ['FR', "France"],
  ['GF', "French Guiana"],
  ['PF', "French Polynesia"],
  ['GA', "Gabon"],
  ['GM', "Gambia"],
  ['GE', "Georgia"],
  ['DE', "Germany"],
  ['GH', "Ghana"],
  ['GI', "Gibraltar"],
  ['GR', "Greece"],
  ['GL', "Greenland"],
  ['GD', "Grenada"],
  ['GP', "Guadeloupe"],
  ['GU', "Guam"],
  ['GT', "Guatemala"],
  ['GG', "Guernsey"],
  ['GN', "Guinea"],
  ['GW', "Guinea-Bissau"],
  ['GY', "Guyana"],
  ['HT', "Haiti"],
  ['HN', "Honduras"],
  ['HK', "Hong Kong SAR China"],
  ['HU', "Hungary"],
  ['IS', "Iceland"],
  ['IN', "India"],
  ['ID', "Indonesia"],
  ['IR', "Iran"],
  ['IQ', "Iraq"],
  ['IE', "Ireland"],
  ['IM', "Isle of Man"],
  ['IL', "Israel"],
  ['IT', "Italy"],
  ['JM', "Jamaica"],
  ['JP', "Japan"],
  ['JE', "Jersey"],
  ['JO', "Jordan"],
  ['KZ', "Kazakhstan"],
  ['KE', "Kenya"],
  ['KI', "Kiribati"],
  ['XK', "Kosovo"],
  ['KW', "Kuwait"],
  ['KG', "Kyrgyzstan"],
  ['LA', "Laos"],
  ['LV', "Latvia"],
  ['LB', "Lebanon"],
  ['LS', "Lesotho"],
  ['LR', "Liberia"],
  ['LY', "Libya"],
  ['LI', "Liechtenstein"],
  ['LT', "Lithuania"],
  ['LU', "Luxembourg"],
  ['MO', "Macao SAR China"],
  ['MG', "Madagascar"],
  ['MW', "Malawi"],
  ['MY', "Malaysia"],
  ['MV', "Maldives"],
  ['ML', "Mali"],
  ['MT', "Malta"],
  ['MH', "Marshall Islands"],
  ['MQ', "Martinique"],
  ['MR', "Mauritania"],
  ['MU', "Mauritius"],
  ['YT', "Mayotte"],
  ['MX', "Mexico"],
  ['FM', "Micronesia"],
  ['MD', "Moldova"],
  ['MC', "Monaco"],
  ['MN', "Mongolia"],
  ['ME', "Montenegro"],
  ['MS', "Montserrat"],
  ['MA', "Morocco"],
  ['MZ', "Mozambique"],
  ['MM', "Myanmar (Burma)"],
  ['NA', "Namibia"],
  ['NR', "Nauru"],
  ['NP', "Nepal"],
  ['NL', "Netherlands"],
  ['NC', "New Caledonia"],
  ['NZ', "New Zealand"],
  ['NI', "Nicaragua"],
  ['NE', "Niger"],
  ['NG', "Nigeria"],
  ['NU', "Niue"],
  ['NF', "Norfolk Island"],
  ['KP', "North Korea"],
  ['MK', "North Macedonia"],
  ['MP', "Northern Mariana Islands"],
  ['NO', "Norway"],
  ['OM', "Oman"],
  ['PK', "Pakistan"],
  ['PW', "Palau"],
  ['PS', "Palestinian Territories"],
  ['PA', "Panama"],
  ['PG', "Papua New Guinea"],
  ['PY', "Paraguay"],
  ['PE', "Peru"],
  ['PH', "Philippines"],
  ['PL', "Poland"],
  ['PT', "Portugal"],
  ['PR', "Puerto Rico"],
  ['QA', "Qatar"],
  ['RE', "Réunion"],
  ['RO', "Romania"],
  ['RU', "Russia"],
  ['RW', "Rwanda"],
  ['WS', "Samoa"],
  ['SM', "San Marino"],
  ['ST', "São Tomé & Príncipe"],
  ['SA', "Saudi Arabia"],
  ['SN', "Senegal"],
  ['RS', "Serbia"],
  ['SC', "Seychelles"],
  ['SL', "Sierra Leone"],
  ['SG', "Singapore"],
  ['SX', "Sint Maarten"],
  ['SK', "Slovakia"],
  ['SI', "Slovenia"],
  ['SB', "Solomon Islands"],
  ['SO', "Somalia"],
  ['ZA', "South Africa"],
  ['KR', "South Korea"],
  ['SS', "South Sudan"],
  ['ES', "Spain"],
  ['LK', "Sri Lanka"],
  ['BL', "St. Barthélemy"],
  ['SH', "St. Helena"],
  ['KN', "St. Kitts & Nevis"],
  ['LC', "St. Lucia"],
  ['MF', "St. Martin"],
  ['PM', "St. Pierre & Miquelon"],
  ['VC', "St. Vincent & Grenadines"],
  ['SD', "Sudan"],
  ['SR', "Suriname"],
  ['SE', "Sweden"],
  ['CH', "Switzerland"],
  ['SY', "Syria"],
  ['TW', "Taiwan"],
  ['TJ', "Tajikistan"],
  ['TZ', "Tanzania"],
  ['TH', "Thailand"],
  ['TL', "Timor-Leste"],
  ['TG', "Togo"],
  ['TK', "Tokelau"],
  ['TO', "Tonga"],
  ['TT', "Trinidad & Tobago"],
  ['TN', "Tunisia"],
  ['TR', "Türkiye"],
  ['TM', "Turkmenistan"],
  ['TC', "Turks & Caicos Islands"],
  ['TV', "Tuvalu"],
  ['VI', "U.S. Virgin Islands"],
  ['UG', "Uganda"],
  ['UA', "Ukraine"],
  ['AE', "United Arab Emirates"],
  ['GB', "United Kingdom"],
  ['US', "United States"],
  ['UY', "Uruguay"],
  ['UZ', "Uzbekistan"],
  ['VU', "Vanuatu"],
  ['VA', "Vatican City"],
  ['VE', "Venezuela"],
  ['VN', "Vietnam"],
  ['WF', "Wallis & Futuna"],
  ['EH', "Western Sahara"],
  ['YE', "Yemen"],
  ['ZM', "Zambia"],
  ['ZW', "Zimbabwe"],
];

/**
 * Names people still type for a country listed under a newer one. The
 * label stays the official name; these only widen what a search matches,
 * so "Turkey" finds Türkiye instead of an empty list.
 */
const SEARCH_ALIASES = {
  TR: ['Turkey'],
};

/** { label, value } pairs for a Select. */
export const COUNTRY_OPTIONS = COUNTRIES.map(([code, name]) => ({ label: name, value: code }));

/** Everything a country search should match on: its name and any alias. */
export const countrySearchText = (code) =>
  [NAMES[code], ...(SEARCH_ALIASES[code] || [])].filter(Boolean).join(' ');

const NAMES = Object.fromEntries(COUNTRIES);

/**
 * The country's name, or the raw code if it isn't one we know. Cases
 * created before a doctor had a country on file have none at all — those
 * read as "Not set" rather than an empty cell.
 */
export const countryName = (code, fallback = 'Not set') => {
  if (!code) return fallback;
  return NAMES[code] || code;
};

/** Do we actually know this code, i.e. is there a flag worth drawing? */
export const isKnownCountry = (code) =>
  !!code && Object.prototype.hasOwnProperty.call(NAMES, String(code).toUpperCase());

/**
 * Flag image for an ISO 3166-1 alpha-2 code.
 *
 * An image rather than the regional-indicator emoji: Chrome on Windows
 * has no flag glyphs at all and renders the pair as the two letters, so
 * the emoji route shows nothing resembling a flag on the very desktop
 * this panel is used from. flagcdn serves the SVG by lowercase code.
 */
export const countryFlagUrl = (code) =>
  isKnownCountry(code) ? `https://flagcdn.com/${String(code).toLowerCase()}.svg` : null;

export default COUNTRIES;
